import types from './actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case types.INIT_EXPERIMENT_CONFIG:
      return action.config
    default:
      return state
  }
}
